export const deClientPortalThreadListPagePages = {
    orders: {
        threadListPage: {
            noTitle: 'Kein Titel',
            saving: 'speichern...',
            taskDetails: 'Aufgabendetails',
            goToOrder: 'Zum Auftrag',
            titlePlaceholder: 'Thema des Gesprächverlaufs',
            comments: 'Kommentare',
            pinned: 'Gepinnt',
            options: 'Optionen',
            notAvailable: 'Noch nicht verfügbar',
            external: 'Extern',
            subjectForExternalCollaboration: 'E-Mail Adresse für die Zusammenarbeit im Auftrag {{orderLabel}}',
            selection: {
                newConversation: 'Neue Unterhaltung',
                item: {
                    noTitle: 'Kein Titel',
                    notifiedUsersTooltip:
                        'Über neue Nachrichten wird aktuell niemand benachrichtigt. Hier klicken, um Benachrichtigte hinzuzufügen.',
                    options: 'Optionen',
                    unpin: 'Unterhaltung abpinnen',
                    pin: 'Unterhaltung pinnen',
                    delete: 'Unterhaltung löschen',
                },
            },
            createDialog: {
                title: 'Neue Unterhaltung',
                create: 'Erstellen',
                cancel: 'Abbrechen',
                topicLabel: 'Titel *',
                participantsLabel: 'Weitere Benachrichtigte hinzufügen...',
                defaultNotifiedUsers: 'Standard-Benachrichtigte dieser neuen Unterhaltung:',
                yourself: 'Sie selbst',
                creator: 'Ersteller/in',
                observers: 'Beobachter/innen',
                assignees: 'Zuständige',
                observersDescriptionSuffix: 'des Auftrags, inkl.',
            },
            emptyState: {
                loadingTitle: 'Unterhaltungen werden geladen...',
                emptyTitle: 'Keine offenen Unterhaltungen vorhanden',
                emptyDescriptionLineOne: 'Starten Sie eine neue Unterhaltung, um Fragen zu stellen, Unterstützung',
                emptyDescriptionLineTwo: 'zu erhalten oder Informationen mit anderen Nutzern auszutauschen.',
                newConversation: 'Neue Unterhaltung',
            },
            orderDropdown: {
                loading: 'Lade Auftragsdaten...',
                label: 'Auftrag',
                noOptions: 'Keine Aufträge gefunden',
                valuationDate: 'Stichtag',
                orderDate: 'Auftragsdatum',
            },
            thread: {
                noMessages: 'Keine Nachrichten',
                deletedMessage: 'Nachricht wurde gelöscht',
                createdBy: 'Unterhaltung wurde von {{userName}} angelegt',
                createdAutomatically: 'Die Unterhaltung wurde automatisch angelegt',
            },
            participantTooltips: {
                none: 'Über neue Nachrichten wird aktuell niemand benachrichtigt. Hier klicken, um Benachrichtigte hinzuzufügen.',
                notified: 'Sie werden über neue Nachrichten benachrichtigt. Benachrichtigunen deaktivieren.',
                notNotified: 'Sie werden über neue Nachrichten nicht benachrichtigt. Benachrichtigungen aktivieren.',
                participantGroup: 'Benachrichtigte',
                observerGroup: 'Beobachter',
                observerTooltip:
                    'Sie beobachten diesen Auftrag. Benachrichtigungen können hier deshalb nicht deaktiviert werden. Beenden Sie die Beobachtung auf der Auftragsseite.',
            },
            menu: {
                unpin: 'Unterhaltung abpinnen',
                pin: 'Unterhaltung pinnen',
                rename: 'Unterhaltung umbenennen',
                goToTask: 'Zur Aufgabe',
                goToOrder: 'Zum Auftrag',
                editParticipants: 'Benachrichtigte bearbeiten',
                stopNotifications: 'Mich nicht mehr benachrichtigen',
                notifyMe: 'Mich benachrichtigen',
                delete: 'Unterhaltung löschen',
                notificationSettings: 'Zu den Benachrichtigungseinstellungen',
            },
            alerts: {
                notNotified: 'Sie werden über neue Nachrichten in dieser Unterhaltung nicht benachrichtigt.',
                aloneStart: 'Sie sind alleine in dieser Unterhaltung. Fügen Sie Benachrichtigte',
                here: 'hier',
                aloneEnd: 'hinzu.',
                emptyParticipants: 'Über neue Nachrichten wird aktuell niemand benachrichtigt.',
            },
            participantsDrawer: {
                title: 'Benachrichtigte bearbeiten',
                addParticipantsLabel: 'Weitere Benachrichtigte hinzufügen...',
                notifyMe: 'Mich benachrichtigen',
                participantCount_one: '{{count}} Benachrichtigte',
                participantCount_other: '{{count}} Benachrichtigte',
                observerCount_one: '{{count}} Beobachter des Auftrags',
                observerCount_other: '{{count}} Beobachter des Auftrags',
                editObservers: 'Beobachter bearbeiten',
                observerInfo:
                    'Beobachter werden per Mail über alle Neuigkeiten zu einem Auftrag informiert, die sie in ihren Benachrichtigungseinstellungen aktiviert haben. Dazu zählen u.A.: Änderungen des Auftragsstatus, verfügbare Entwürfe, neue Nachrichten und Aufgabenupdates. Bearbeiten Sie Ihren Status als Beobachter auf der Auftragsseite.',
                responsible: 'Zuständig',
            },
            message: {
                deleteTitle: 'Nachricht löschen',
                deleteDialogContent: 'Möchten Sie die Nachricht endgültig löschen?',
                deleteConfirm: 'Endgültig löschen',
                edit: 'Nachricht bearbeiten',
                delete: 'Nachricht löschen',
                edited: 'bearbeitet',
                attachments: 'Anhänge',
                deletedMessage: 'Nachricht wurde gelöscht',
                system: 'System',
            },
            textEditor: {
                noMentionResults: 'Keine Ergebnisse',
                placeholder: 'Neue Nachricht',
                attachmentTooLarge: 'Die Anhänge sind zusammen größer als 7,5 MB.',
                toolbar: {
                    textStyle: 'Textstil',
                    bold: 'Fett',
                    italic: 'Kursiv',
                    bulletedList: 'Aufzählung',
                    numberedList: 'Nummerierte Liste',
                    headingOptions: {
                        paragraph: 'Text',
                        h2: 'Headline 1',
                        h3: 'Headline 2',
                        h4: 'Headline 3',
                        h5: 'Headline 4',
                    },
                },
            },
            externalEmail: {
                info: 'Nachrichten und Dokumente (max. 7,5 MB) werden',
                infoSecondLine: 'als E-Mail an den externen Kontakt versendet.',
                details: 'E-Mail-Details',
                messageMetadata: {
                    sender: 'Von',
                    recipient: 'An',
                    subject: 'Betreff',
                },
            },
        },
    },
}
